import React, { useState, useRef } from 'react';
import Product from '../Product';
import {ProductGroup, NeuroMessage, ProductPagePropTypes, usePages} from '@ignitesales/neuro-application/src/neuro-guide';
import { useUser, useAnalytics } from '@ignitesales/neuro-application/src/neuro-guide/hooks';
import ShareViaSmsModal from '@ignitesales/neuro-application/src/neuro-guide/components/ShareViaSmsModal';
import ShareViaEmailModal from '../modals/ShareViaEmailModal';
import ShareViaEmailComplete from '../modals/ShareViaEmailComplete';
import ContactFormModal from '../modals/ContactFormModal';
import PrintButton from '@ignitesales/neuro-application/src/neuro-guide/components/PrintButton';
import { AnswersList } from '@ignitesales/neuro-application/src/neuro-guide/guide-framework';

function SummaryPage({ componentClass, productGroups }) {
  const { goToPreviousPage } = usePages();
  const { uuid } = useUser();
  const { actionCompleted, actionStarted  } = useAnalytics();
  const [ showContactFormModal, setShowContactFormModal ] = useState(false);
  const [ showShareViaSmsModal, setShowShareViaSmsModal ] = useState(false);
  const [ showShareViaEmailModal, setShowShareViaEmailModal ] = useState(false);
  const [ showShareViaEmailComplete, setShowShareViaEmailComplete ] = useState(false);
  const [ selectedProduct, setSelectedProduct ] = useState({});
  const [ leadTransmitted, setLeadTransmitted ] = useState(false);
  const [ onEmailSubmission, setOnEmailSubmission ] = useState(false);

  const renderProductGroup = (productGroup, subGroups, products) => {
    const cssBEM = 'product-group';

    return (products.length > 0 || subGroups.length > 0) && <div className={cssBEM} key={ productGroup.name }>
      { subGroups || null }
      { products || null }
    </div>;
  };

  const onEmailComplete = () => {
    setOnEmailSubmission(true);
    actionCompleted({ actionName: 'shareViaEmailCompleted' });
  };

  const onScheduleClick = () => {
    setShowContactFormModal(true);
    actionStarted({ actionName: 'makeAppointmentClicked' });
  }


  const onSuccessAction = (e) => {
    e.preventDefault();
    setShowSuccessFormModal(false);
  };

  const onContactSuccess = (lead) => {
    setShowContactFormModal(false);
    setShowSuccessFormModal(true);
    setLeadTransmitted(true);
    actionCompleted({ actionName: 'makeAppointmentCompleted' });

    const sendEmailParams = {
      email: lead.email,
      fromEmail: null,
      copyMe: false,
    };

    if( !onEmailSubmission ) {
      dispatch(sendResultsViaEmail(sendEmailParams));
    }
  };

  const renderProduct = (product) => {
    return <Product product={ product } key={ product.id } isDetails />;
  };

  const contactFormModal = (
    <ContactFormModal
      className={`${componentClass}__contactModal contactForm`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showContactFormModal}
      onClose={() => setShowContactFormModal(false)}
      onComplete={ onContactSuccess }
      selectedProduct= { selectedProduct }
    />
  );

  const shareViaSmsModal = (
    <ShareViaSmsModal
      className={`${componentClass}__smsModal shareModal`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaSmsModal}
      onClose={() => setShowShareViaSmsModal(false)}
    />
  );

  const shareViaEmailModal = (
    <ShareViaEmailModal
      className={`${componentClass}__emailModal shareModal`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaEmailModal}
      onClose={() => setShowShareViaEmailModal(false)}
      onEmailComplete={onEmailComplete}
    />
  );

  const shareViaEmailComplete = (
    <ShareViaEmailComplete
      className={`${componentClass}__emailModal emailComplete`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaEmailComplete}
      onClose={() => setShowShareViaEmailComplete(false)}
    />
  );


  const onShareViaSmsClicked = () => {
    setShowShareViaSmsModal(true);
    actionStarted({ actionName: 'shareViaSmsClicked' });
  };

  const onShareViaEmailClicked = () => {
    setShowShareViaEmailModal(true);
    actionStarted({ actionName: 'shareViaEmailClicked' });
  };

  const myRef = useRef(null);
  const scrollToAnswers = () => myRef.current.scrollIntoView({
    behavior: "smooth",
  });


  return (
    <div className={componentClass}>
      <div className={ `${ componentClass }__header` }>
        <div className={ `${ componentClass }__header--tag` }>
          <NeuroMessage id='summary.page.title' tagName='h1' />
          <button className="btn" onClick={onScheduleClick} >
            <NeuroMessage id='summary.page.cta' />
          </button>
        </div>
        <div className={ `${ componentClass }__header--answers` }>
          <NeuroMessage id='summary.recommendations.title' tagName='h4' />
          <button className="btn" onClick={scrollToAnswers}>
            <NeuroMessage id='summary.answers.cta' />
          </button>
        </div>
      </div>

      <div className={ `${ componentClass }__products` }>{ productGroups.map(g =>
        <ProductGroup group={ g } renderGroupFn={ renderProductGroup } renderProductFn={ renderProduct } key={ g.name } />
      )}
      <div className="actions">
            <div className="sms action" onClick={onShareViaSmsClicked}>
              <span className="fa fa-mobile"/>
              <NeuroMessage id="summary.mobile" tagName='h5' />
            </div>

            <div className="email action" onClick={ onEmailSubmission || leadTransmitted ? () => { setShowShareViaEmailComplete(true); } : onShareViaEmailClicked }>
              <span className="fa fa-envelope"/>
              <NeuroMessage id="summary.email" tagName='h5' />
            </div>

            <PrintButton className="print action" tagName="div">
              <span className="fa fa-print"/>
              <NeuroMessage id="summary.print" tagName='h5' />
            </PrintButton>
        </div>
      </div>
      <button onClick={goToPreviousPage} className="btn btn-secondary mt-5"><NeuroMessage id="nav.prev"/></button>

      <div className={ `${ componentClass }__answers` } ref={myRef}>
        <NeuroMessage id="summary.answers.title" tagName='h2' />
        <AnswersList usePathOrder />
      </div>

      { contactFormModal }
      { shareViaSmsModal }
      { shareViaEmailModal }

    </div>
  );
}

SummaryPage.propTypes = ProductPagePropTypes;

export default SummaryPage;
